export default function(store, action) {
  return {
    ...store,
    hint: {
      ...store.hint,
      anchorEl: null,
      block: action.force ? false : store.hint.block,
      open: action.force ? false : store.hint.block ? store.hint.open : false,
      prices: action.prices,
      restrictions: action.restrictions,
    },
  }
}
